import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { configureTelemetry } from '@ms/yammer-telemetry';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';

import { persistConfig } from '../../persistedState';

import { getConfig } from './getConfig';
import { getTelemetryClientId } from './getTelemetryClientId';

type SetupTelemetry = (options?: { readonly skipNextCleanup?: boolean }) => Promise<void>;
export const setupTelemetry: SetupTelemetry = async (options) => {
  const config = await getConfig();

  const shouldLogProtobufEventsToConsole = (await getPersistedExperimentTreatment(
    persistConfig.key,
    'LogProtobufEvents'
  )) as boolean;

  const enableLongAnimationFrameTimingReporting = (await getPersistedExperimentTreatment(
    persistConfig.key,
    'ReportLongAnimationFrameTiming'
  )) as boolean;

  const telemetryClientId = await getTelemetryClientId();

  configureTelemetry({
    config,
    telemetryClientId,
    hostingConfig: readHostingConfiguration(),
    registerUnhandledEventsListener: true,
    shouldLogProtobufEventsToConsole,
    enableLongAnimationFrameTimingReporting,
    isMsal: true,
    ...options,
  });
};
